import React from 'react';
import { FilterParams } from '../pages/AdministrationOfContinuousEducation/liste-prezenca-for-trainings.component';

export const handlePopupScroll = (
  e: React.UIEvent<HTMLDivElement, UIEvent>,
  loading: boolean,
  hasMore: boolean,
  setQueryParams: React.Dispatch<React.SetStateAction<FilterParams>>,
) => {
  const { scrollTop, offsetHeight, scrollHeight } = e.currentTarget;
  const isAtBottom = scrollTop + offsetHeight >= Math.ceil(scrollHeight) - 1;
  if (isAtBottom && !loading && hasMore) {
    setQueryParams((state: FilterParams) => ({
      ...state,
      page: state.page + 1,
    }));
  }
};
